/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PhrMeasurement, PhrMeasurementFromJSON, PhrMeasurementFromJSONTyped, PhrMeasurementToJSON } from "./";

export const PhrSerumCreatinineTypename = "PhrSerumCreatinine" as const;

/**
 *
 * @export
 * @interface PhrSerumCreatinine
 */
export interface PhrSerumCreatinine {
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrSerumCreatinine
   */
  egfr?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrSerumCreatinine
   */
  other?: PhrMeasurement;
  /**
   *
   * @type {string}
   * @memberof PhrSerumCreatinine
   */
  reason?: string;
  /**
   *
   * @type {string}
   * @memberof PhrSerumCreatinine
   */
  target?: string;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrSerumCreatinine
   */
  violetAbsorptionSpectrophotometry?: PhrMeasurement;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrSerumCreatinine
   */
  readonly __typename?: string;
}

export function PhrSerumCreatinineFromJSON(json: any): PhrSerumCreatinine {
  return PhrSerumCreatinineFromJSONTyped(json, false);
}

export function PhrSerumCreatinineFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrSerumCreatinine {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrSerumCreatinineTypename,

    egfr: !exists(json, "egfr") ? undefined : PhrMeasurementFromJSON(json["egfr"]),
    other: !exists(json, "other") ? undefined : PhrMeasurementFromJSON(json["other"]),
    reason: !exists(json, "reason") ? undefined : json["reason"],
    target: !exists(json, "target") ? undefined : json["target"],
    violetAbsorptionSpectrophotometry: !exists(json, "violet_absorption_spectrophotometry")
      ? undefined
      : PhrMeasurementFromJSON(json["violet_absorption_spectrophotometry"]),
  };
}

export function PhrSerumCreatinineToJSON(object?: PhrSerumCreatinine | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    egfr: PhrMeasurementToJSON(value.egfr),
    other: PhrMeasurementToJSON(value.other),
    reason: value.reason,
    target: value.target,
    violet_absorption_spectrophotometry: PhrMeasurementToJSON(value.violetAbsorptionSpectrophotometry),
  };
}
